import { serializeSvg, createSvgBlob } from "./svg";
import { convertSvgToCanvas } from "./canvas";
import { downloadCanvasAsPng } from "./download";

export const downloadAsPng = (
  svgElement: SVGElement,
  canvasWidth: number,
  canvasHeight: number,
): void => {
  if (!svgElement) {
    console.error("SVG element not found");
    return;
  }

  const svgData = serializeSvg(svgElement);
  const svgBlob = createSvgBlob(svgData);
  const svgUrl = URL.createObjectURL(svgBlob);

  convertSvgToPngAndDownload(svgUrl, canvasWidth, canvasHeight);
};

const convertSvgToPngAndDownload = (
  svgUrl: string,
  canvasWidth: number,
  canvasHeight: number,
): void => {
  convertSvgToCanvas(svgUrl, canvasWidth, canvasHeight)
    .then((canvas) => {
      downloadCanvasAsPng(canvas, svgUrl);
    })
    .catch((error) => {
      console.error(error.message);
      URL.revokeObjectURL(svgUrl);
    });
};
